export default __webpack_public_path__ + "static/media/P-029.89d71f41.png";